import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Label, Menu, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css";

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

export enum longtermCarePlanMenuTab {
  TAB1 = `Types of Facilities`,
  TAB2 = `Costs of Care`,
  TAB3 = `Long-Term Care Insurance`
}

export const LongTermCarePlanLearnMore: React.FC = () => {
  const [activeLearnMoreMenuItem, setActiveLearnMoreMenuItem] = useState(longtermCarePlanMenuTab.TAB1);
  const [activeAccordionIndexes] = useState([0,1,2,3,4]);const renderAccordionUnderstanding = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} > 
        <p className={styles.learnMoreAccordionText} > 
          Visiting several long-term care and assisted living facilities provides the opportunity to compare and ask 
          questions of staff and residents. We encourage you to contact the ones of interest to identify the most suitable 
          ones to visit. You will need to think about what is important in a facility, such as the location, size, and 
          types of services.
          <br/><br/>          
          It is always a good idea to request a copy of a contract, and it is not a good sign if a facility will not 
          provide a contract until a potential resident is ready to sign. You should never sign a contract the day of 
          the visit.
          <br/><br/>
          <span className={styles.learnMoreAccordionTextEmphasis} > 
            Before deciding about a facility, it is important to take the contract home and review it thoroughly, preferably 
            with a lawyer and knowledgeable family members. </span> 
        </p>
      </Segment>
      </>
    );
  };
  const displayActiveMenuSection = () => {
      switch(activeLearnMoreMenuItem) {
        case longtermCarePlanMenuTab.TAB1:  
          return renderMenuTab1();
        case longtermCarePlanMenuTab.TAB2:  
          return renderMenuTab2();
        case longtermCarePlanMenuTab.TAB3:  
          return renderMenuTab3();
    }
  };
  const renderMenuTab1 = () => {
    return (
      <>
      <Grid stackable doubling columns="equal" padded >
        <Grid.Column >
          <Header className={styles.learnMoreBulletedListHeader} > Skilled Care </Header>
          <p className={styles.learnMoreAccordionText} > 
            Provides non-medical care to help people with daily living activities. </p>
          <p className={styles.learnMoreAccordionText} > 
            This includes things like bathing, cleaning, and meals. Those providing care do not have to be licensed 
            medical professionals. </p>
        </Grid.Column>
        <Grid.Column >     
          <Header className={styles.learnMoreBulletedListHeader} > Intermediate Care </Header>     
          <p className={styles.learnMoreAccordionText} > 
            Designed to provide care for those who are unable to live independently and need some medical attention, 
            but do not require constant medical supervision. </p>
          <p className={styles.learnMoreAccordionText}  style={{marginBottom: '1rem'}}> 
            An intermediate care facility provides less care than a skilled care facility, but more than an assisted 
            living facility. </p>
        </Grid.Column>
        <Grid.Column >  
          <Header className={styles.learnMoreBulletedListHeader} > Assisted Living </Header>    
          <p className={styles.learnMoreAccordionText} > 
            Provides full-time care and medical assistance to residents by licensed health care professionals. </p>
          <p className={styles.learnMoreAccordionText} > 
            These facilities can offer a wide range of services and care such as physical therapy, wound care, 
            injections, occupational therapy, and more. </p>
        </Grid.Column>
      </Grid>
      </>
    );
  };
  const renderMenuTab2 = () => {
    return (
      <>
      <p className={styles.learnMoreAccordionText} style={{marginTop: '2rem'}}  > 
        As the older adult ages, they may no longer be able to live independently. There are different types of 
        residential facilities that are designed to offer varying levels of personal and medical care. Home care 
        organizations also provide medical and personal care within the older adult's home on a short-term or 
        long-term basis. </p>
      <p className={styles.learnMoreAccordionText} > 
        Many people don't think of the costs associated with long-term care until it is too late. It is important 
        to understand the potential costs and to develop a plan with this scenario in mind. </p>
      <p className={styles.learnMoreAccordionTextEmphasis} >        
        The costs and payment options available are dependent on the facility and the financial situation of the 
        older adult. </p>        
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '3rem'}} > 
        There are options available to cover these expenses such as Medicare, Medicaid, some veterans' benefits, 
        long-term care insurance, and private funding. </p>
      </>
    );
  };
  const renderMenuTab3 = () => {
    return (
      <>
      <p className={styles.learnMoreAccordionText} style={{marginTop: '2rem'}}  > 
        Many older adults will need long-term care services at some point in their lives. Long-term care can 
        include residential facilities, but it also includes in-home care including help with daily activities 
        and things like physical and occupational therapy. These services can be expensive and traditional 
        insurance and Medicare does not usually cover the cost. </p>
      <p className={styles.learnMoreAccordionText} > 
        <b> Long-term care insurance can help to pay for these services should the older adult need  them. </b> It 
        is important to look into this before the older adult needs long-term care. A typical policy will pay out a 
        predetermined amount for each service. </p>
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '3rem'}} > 
        <b>Traditional long-term care insurance</b> requires a monthly premium for coverage, which the older adult 
        may or may not end up using. <b>Hybrid long-term care/life insurance</b> is also an option where if older 
        adult ends up needing care, the costs will come out of the death benefit. If not, the death benefit will 
        remain as it is. </p> 
</>
    );
  };
  
  const accordions = [
    { key: 'understanding',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Choosing a Residential Facility </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionUnderstanding()}/>)
      }
    }
  ];
  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}Caregiver3.jpeg)`, }}>
        <div className={styles.learnMoreModalContent}  >

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

          <div className={styles.learnMoreMenuDiv} >
            <Segment.Group raised className={styles.learnMoreMenuSegmentGroup} >
              <Menu attached='top' tabular color="green" className={styles.learnMoreMenuTab} widths='four'>
                <Menu.Item
                  name={longtermCarePlanMenuTab.TAB1}
                  active={activeLearnMoreMenuItem === longtermCarePlanMenuTab.TAB1}
                  onClick={() => setActiveLearnMoreMenuItem(longtermCarePlanMenuTab.TAB1)}
                />
                <Menu.Item
                  name={longtermCarePlanMenuTab.TAB2}
                  active={activeLearnMoreMenuItem === longtermCarePlanMenuTab.TAB2}
                  onClick={() => setActiveLearnMoreMenuItem(longtermCarePlanMenuTab.TAB2)}
                />
                <Menu.Item
                  name={longtermCarePlanMenuTab.TAB3}
                  active={activeLearnMoreMenuItem === longtermCarePlanMenuTab.TAB3}
                  onClick={() => setActiveLearnMoreMenuItem(longtermCarePlanMenuTab.TAB3)}
                />
              </Menu>
              <Segment attached='bottom' raised className={styles.learnMoreMenuTabbedSegment} >
                {displayActiveMenuSection()}
              </Segment>
            </Segment.Group>
          </div> 
    
        </div>
      </Segment>    
    </>
    );  
};
